import React from 'react';

function HamburgerIcon({ fill = '#000', width = null, height = null }) {
    return (
        <svg className="icon hamburger-icon" viewBox="0 0 20 16" width={width} height={height}>
            <path
                fill={fill}
                d="M19.25 14.5c.414 0 .75.336.75.75s-.336.75-.75.75H.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h18.5zm0-7.25c.414 0 .75.336.75.75s-.336.75-.75.75H.75C.336 8.75 0 8.414 0 8s.336-.75.75-.75h18.5zm0-7.25c.414 0 .75.336.75.75s-.336.75-.75.75H.75C.336 1.5 0 1.164 0 .75S.336 0 .75 0h18.5z"
                transform="translate(-15 -41) translate(15 41)"
            />
        </svg>
    );
}
export default HamburgerIcon;
